// extracted by mini-css-extract-plugin
export default {"users":"StackedAvatars_users__CiUl-","innerAvatar":"StackedAvatars_innerAvatar__fZCeR","plus":"StackedAvatars_plus__pR9pa"};